import { css } from "@emotion/react";

import Notifications from "context/notifications/NotificationsState";
import { useMediaQueries } from "shared";

import Settings from "./Settings";
import { ControlsProps } from "./types";

const Controls = ({ hideNotifications, handleDrawer }: ControlsProps) => {
    const { toMd } = useMediaQueries();

    return (
        <ul
            css={css({
                display: "flex",
                alignItems: "center",
                marginLeft: toMd ? "0" : "8px",

                "button + button": {
                    marginLeft: toMd ? "0" : "8px"
                },

                "@media (max-width: 839px)": {
                    display: "block"
                }
            })}
        >
            {!hideNotifications && <Notifications />}

            <Settings handleDrawer={handleDrawer} />
        </ul>
    );
};

export default Controls;
